export default __webpack_public_path__ + "static/media/tss.72bb5c80.svg";